var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alerts.length)?_c('div',{staticClass:"alert",class:_vm.alertClass},[_vm._l((_vm.alerts),function(alert){return [_vm._v(_vm._s(alert)),_c('br')]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }